

interface DropdownTriggerProps {
  children: React.ReactNode;
  selectClassName?: string;
  selectArrowClassName?: string;
  selectArrowPath?: string;
  onClick?: () => void;
}

const DropdownTrigger = ({
  children,
  selectArrowClassName,
  selectClassName,
  selectArrowPath,
  ...props
}: DropdownTriggerProps) => {
  return (
    <>
      <button
        type="button"
        {...props}
        className={`flex items-center ${selectClassName}`}
      >
        {children}
        <img
          src={selectArrowPath}
          alt="arrow"
          className={selectArrowClassName}
        />
      </button>
    </>
  );
};

export default DropdownTrigger;
